var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BackgroundImage",class:{ 'is-cover-image': _vm.cover },style:({ backgroundImage: _vm.image })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }